import styled from "@emotion/styled";

export const StyledWorks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
